import { render, staticRenderFns } from "./figure.vue?vue&type=template&id=3ab6e9d4"
import script from "./figure.vue?vue&type=script&lang=ts"
export * from "./figure.vue?vue&type=script&lang=ts"
import style0 from "./figure.vue?vue&type=style&index=0&id=3ab6e9d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports